import { makeStyles } from 'tss-react/mui';

const useStylesStatusBar: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  statusBarContainer: {
    marginRight: 20,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      '& > div > div': {
        display: 'inline-flex',
        '&:first-of-type': {
          width: '80%',
        },
        '&:last-of-type': {
          width: 'auto',
        },
      },
    },
  },
  statusBar: {
    background: `${theme.palette.success.main} !important`,
    color: `${theme.palette.common.white} !important`,
  },
  statusBarError: {
    background: `${theme.palette.error.main} !important`,
    color: `${theme.palette.common.white} !important`,
  },
  statusBarButton: {
    padding: '10px !important',
    marginLeft: '20px !important',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0 !important',
    },
  },
  statusBarIcon: {
    verticalAlign: 'middle',
    marginRight: 10,
    '& > svg': {
      color: `${theme.palette.common.white} !important`,
      fontSize: 20,
    },
  },
}));

export default useStylesStatusBar;
